// AutoLogout.js
import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../AuthContext";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import {jwtDecode} from "jwt-decode";
import { toast } from "react-toastify";
import socket from "./constant/socket";

let triggerLogoutExternally = null;
let is_Session_Alert=false

export const triggerAutoLogout = () => {
  if (typeof triggerLogoutExternally === "function") {
    triggerLogoutExternally();
    is_Session_Alert=true
  }
};

const AutoLogout = () => {
  const { logout, authenticated ,isBlock} = useAuth();
  const navigate = useNavigate();
  const timeoutRef = useRef(null);
  const intervalRef = useRef(null);

  const logoutFun = () => {
    is_Session_Alert=false
    toast.dismiss()
    toast.success("Logout Successful.")
    socket.disconnect();
    setTimeout(() => {
      logout();
      navigate("/");
    }, 2000);
  };

  const changePasswordLogout=()=>{
    socket.disconnect();
    setTimeout(() => {
      logout();
      navigate("/");
    }, 2000);
  }

  const logoutAlert = () => {
    if (authenticated && localStorage.getItem("token")) {
      localStorage.setItem("session_expire_manager","1")
      confirmAlert({
        title: "Session Expired",
        message: "Your session has expired. Please log in again.",
        buttons: [
          {
            label: "Ok",
            onClick: () => logoutFun(),
          },
        ],
        closeOnEscape: false,
        closeOnClickOutside: false,
      });
    }
  };
  useEffect(() => {
    if(localStorage.getItem("session_expire_manager") &&  localStorage.getItem("session_expire_manager")==1){
     logoutAlert()
    }
 }, [])
  // Expose the alert trigger
  useEffect(() => {
    triggerLogoutExternally = logoutAlert;

    return () => {
      triggerLogoutExternally = null;
    };
  }, [authenticated]);

  const resetTimer = () => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(logoutAlert, 59 * 60 * 1000); // 15 min
  };

  useEffect(() => {
    const events = ["mousemove", "mousedown", "click", "scroll", "keydown", "touchstart"];
    events.forEach((event) => window.addEventListener(event, resetTimer));
    resetTimer();

    intervalRef.current = setInterval(() => {
      const token = localStorage.getItem("token");
      if (token) {
        try {
          const decoded = jwtDecode(token);
          const now = Date.now() / 1000; 
          if (decoded.exp && now >= decoded.exp && !is_Session_Alert) {
            logoutAlert();
            is_Session_Alert=true
          }
        } catch (err) {
          logoutAlert();
          is_Session_Alert=true
        }
      }
    }, 10000);

    return () => {
      events.forEach((event) => window.removeEventListener(event, resetTimer));
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, []);

  const blockAlert = () => {
    if (authenticated && localStorage.getItem("token")) {
      confirmAlert({
        title: "Blocked",
        message: "You have been blocked by admin.",
        buttons: [
          {
            label: "Ok",
            onClick: () => logoutFun(),
          },
        ],
        closeOnEscape: false,
        closeOnClickOutside: false,
      });
    }
  };

  useEffect(() => {
     if(isBlock=="1"){
      blockAlert()
     }
  }, [isBlock])
  

  useEffect(() => {
    socket.on("forceLogout", () => {
      blockAlert()
    });
    socket.on("changepasswordLogout", () => {
      changePasswordLogout()
    });
    // socket.on("newLocationOpen", () => {
    //   changePasswordLogout()
    // });
    
    return () => {
      socket.off("forceLogout");
      socket.off("changepasswordLogout");
      // socket.off("newLocationOpen");
    };
  }, []);

  return null;
};

export default AutoLogout;
